/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";
import { navItems } from "sections/menu-config";
import { useRBAC } from "cms/auth/hooks/use-RBAC";

const useAllowedMenu = function () {

    const [menu,setMenu] = useState([]);
    const { permissionsReady, checkPermission } = useRBAC();

    const buildMenu = async () => {
        const _menu = [];
        for (const menu_item of navItems) {
            const { permission: _permission } = menu_item;
            const hasPermission = await checkPermission(_permission);
            if (hasPermission) {
                _menu.push(menu_item);
            }
        }
        setMenu(_menu);
    };
    useEffect(() => {
        if (permissionsReady) {
            buildMenu();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[permissionsReady]);

    return { menu };
};

export { useAllowedMenu };
